import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
  noContentElementInitialState,
  objectContentElementInitialState,
  updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  confirmerPaiementSouscription: { ...noContentElementInitialState },
  paymentTrace: { ...objectContentElementInitialState },

};
const confirmerPaiementSouscription = (state) => {
  return updateState("confirmerPaiementSouscription", state, {
    ...noContentElementInitialState,
    isLoading: true,
  });
};

const confirmerPaiementSouscriptionSuccess = (state) => {
  return updateState("confirmerPaiementSouscription", state, {
    isLoading: false,
    isSuccessed: true,
  });
};

const confirmerPaiementSouscriptionFail = (state, payload) => {
  return updateState("confirmerPaiementSouscription", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
const confirmerPaiementSouscriptionReinitializationAction = (state) => {
  return updateState("confirmerPaiementSouscription", state, {
    ...noContentElementInitialState,
  });
};

// ----------------------------- TRACE PAYMENT IN ACCOUNT -----------------------
const tracePaymentInAccount = (state) => {
  return updateState("paymentTrace", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const tracePaymentInAccountSuccess = (state, payload) => {
  return updateState("paymentTrace", state, {
    isLoading: false,
    isSuccessed: true,
    content: payload,
  });
};

const tracePaymentInAccountFail = (state, payload) => {
  return updateState("paymentTrace", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*************************************************************************** */
const confirmerPaiementSouscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION:
      return confirmerPaiementSouscription(state, action);
    case ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_SUCCESS:
      return confirmerPaiementSouscriptionSuccess(state);
    case ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_FAIL:
      return confirmerPaiementSouscriptionFail(state, action.payload);
    case ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_REINITIALIZATION:
      return confirmerPaiementSouscriptionReinitializationAction(state);
    default:
      return state;
  }
};

export default confirmerPaiementSouscriptionReducer;
